export const CornerRadius = {
  None: 0 as const,
  Micro: 4 as const,
  Small: 8 as const,
  Normal: 12 as const,
  Medium: 16 as const,
  Large: 20 as const,
  ExtraLarge: 24 as const,
  Huge: 32 as const,
  Full: 999 as const,
};
